"use client";

import { c as _c } from "react/compiler-runtime";
import { AuthContext } from "@/components/auth/Auth";
import type { ActivityLogParams } from "@/components/profile-activity/ProfileActivityLogs";
import { QueryKey } from "@/components/react-query-wrapper/ReactQueryWrapper";
import type { ApiProfileRepRatesState } from "@/entities/IProfile";
import type { ApiIdentity } from "@/generated/models/ApiIdentity";
import { commonApiFetch } from "@/services/api/common-api";
import { RateMatter } from "@/types/enums";
import { useQuery } from "@tanstack/react-query";
import { useParams } from "next/navigation";
import { useContext, useEffect, useState } from "react";
import UserPageRateWrapper from "../utils/rate/UserPageRateWrapper";
import type { ProfileRatersParams } from "../utils/raters-table/wrapper/ProfileRatersTableWrapper";
import ProfileRatersTableWrapper from "../utils/raters-table/wrapper/ProfileRatersTableWrapper";
import UserPageRepHeader from "./header/UserPageRepHeader";
import UserPageRepNewRep from "./new-rep/UserPageRepNewRep";
import UserPageRepReps from "./reps/UserPageRepReps";
import UserPageRepActivityLog from "./UserPageRepActivityLog";
export default function UserPageRep(t0) {
  const $ = _c(40);
  const {
    profile,
    initialRepReceivedParams,
    initialRepGivenParams,
    initialActivityLogParams
  } = t0;
  const {
    connectedProfile
  } = useContext(AuthContext);
  const params = useParams();
  let t1;
  if ($[0] !== params?.user) {
    t1 = (params?.user as string)?.toLowerCase();
    $[0] = params?.user;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const user = t1;
  const [rater, setRater] = useState(undefined);
  let t2;
  if ($[2] !== connectedProfile?.handle) {
    t2 = () => setRater(connectedProfile?.handle?.toLowerCase());
    $[2] = connectedProfile?.handle;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== connectedProfile) {
    t3 = [connectedProfile];
    $[4] = connectedProfile;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  useEffect(t2, t3);
  let t4;
  let t5;
  if ($[6] !== rater || $[7] !== user) {
    t4 = [QueryKey.PROFILE_REP_RATINGS, {
      rater,
      handleOrWallet: user
    }];
    t5 = async () => await commonApiFetch({
      endpoint: `profiles/${user}/rep/ratings/received`,
      params: rater ? {
        rater
      } : {}
    });
    $[6] = rater;
    $[7] = user;
    $[8] = t4;
    $[9] = t5;
  } else {
    t4 = $[8];
    t5 = $[9];
  }
  const t6 = !!user;
  let t7;
  if ($[10] !== t4 || $[11] !== t5 || $[12] !== t6) {
    t7 = {
      queryKey: t4,
      queryFn: t5,
      enabled: t6
    };
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  const {
    data: repRates
  } = useQuery(t7);
  const t8 = repRates ?? null;
  let t9;
  if ($[14] !== t8) {
    t9 = <UserPageRepHeader repRates={t8} />;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  const t10 = repRates ?? null;
  let t11;
  if ($[16] !== profile || $[17] !== t10) {
    t11 = <UserPageRepNewRep profile={profile} repRates={t10} />;
    $[16] = profile;
    $[17] = t10;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== profile || $[20] !== t11) {
    t12 = <UserPageRateWrapper profile={profile} type={RateMatter.REP}>{t11}</UserPageRateWrapper>;
    $[19] = profile;
    $[20] = t11;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  const t13 = repRates ?? null;
  let t14;
  if ($[22] !== profile || $[23] !== t13) {
    t14 = <UserPageRepReps repRates={t13} profile={profile} />;
    $[22] = profile;
    $[23] = t13;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  let t15;
  if ($[25] !== initialRepGivenParams) {
    t15 = <div><ProfileRatersTableWrapper initialParams={initialRepGivenParams} /></div>;
    $[25] = initialRepGivenParams;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[27] !== initialRepReceivedParams) {
    t16 = <div><ProfileRatersTableWrapper initialParams={initialRepReceivedParams} /></div>;
    $[27] = initialRepReceivedParams;
    $[28] = t16;
  } else {
    t16 = $[28];
  }
  let t17;
  if ($[29] !== t15 || $[30] !== t16) {
    t17 = <div className="tw-mt-6 tw-grid tw-grid-cols-1 tw-gap-x-8 tw-gap-y-6 lg:tw-mt-8 lg:tw-gap-x-10 lg:tw-gap-y-10 xl:tw-grid-cols-2">{t15}{t16}</div>;
    $[29] = t15;
    $[30] = t16;
    $[31] = t17;
  } else {
    t17 = $[31];
  }
  let t18;
  if ($[32] !== initialActivityLogParams) {
    t18 = <div className="tw-mt-6 lg:tw-mt-8"><UserPageRepActivityLog initialActivityLogParams={initialActivityLogParams} /></div>;
    $[32] = initialActivityLogParams;
    $[33] = t18;
  } else {
    t18 = $[33];
  }
  let t19;
  if ($[34] !== t12 || $[35] !== t14 || $[36] !== t17 || $[37] !== t18 || $[38] !== t9) {
    t19 = <div className="tailwind-scope">{t9}{t12}{t14}{t17}{t18}</div>;
    $[34] = t12;
    $[35] = t14;
    $[36] = t17;
    $[37] = t18;
    $[38] = t9;
    $[39] = t19;
  } else {
    t19 = $[39];
  }
  return t19;
}